// Functions to update text box properties
function updateFontStyle(canvasText, fontStyle) {

    // Map custom font names to their CSS classes
    const fontClassMap = {
        'Benguiat BK': 'benguiat-bk',
        'Cityd Bold': 'cityd-bold',
        'Demonized': 'demonized',
        'Deadknight': 'Deadknight',
        'Eurostile': 'eurostile',
        'Evogria': 'evogria',
        'Evogria Italic': 'evogria-italic',
        'Famous College': 'Famous-College',
        'Keylock Fighter': 'Keylock-Fighter',
        'Magnolia Script': 'magnolia-script',
        'Rock Road': 'Rock-Road',
        'Srabi Script': 'srabi-script',
        'Steel City': 'Steel-City',
        'Superstar': 'superstar-m54',
        'SwitzerlandCond Italic': 'swzconbi',
        'SwitzerlandCond': 'swzconbn',
    };
    canvasText.style.fontFamily = fontClassMap[fontStyle];

    switch(fontStyle){
        case 'Benguiat BK':
        case 'Steel City':
            canvasText.style.paddingLeft = 10 + 'px';
            break;
        
        case 'Cityd Bold':
        case 'Eurostile':
        case 'Evogria':
        case 'Superstar':
        case 'SwitzerlandCond':
            break;

        case 'Evogria Italic':
        case 'SwitzerlandCond Italic':
        case 'Rock Road':
            canvasText.style.paddingLeft = 12.5 + 'px';
            canvasText.style.paddingRight = 10 + 'px';
            break;

        case 'Magnolia Script':
        case 'Srabi Script':
            canvasText.style.paddingLeft = 25 + 'px';
            canvasText.style.paddingRight = 18 + 'px';
            canvasText.style.paddingTop = 5 + 'px';
            canvasText.style.paddingBottom = 10 + 'px';
            break;

        case 'Demonized':
        case 'Keylock Fighter':
            canvasText.style.paddingLeft = 10 + 'px';
            canvasText.style.paddingRight = 18 + 'px';
            canvasText.style.paddingTop = 5 + 'px';
            canvasText.style.paddingBottom = 7.5 + 'px';
            break;
    }
}

function updateFontColor(canvasText, fontColor) {
    canvasText.style.color = fontColor;
}

function updateOutlineColor(canvasText, outlineColor) {
    canvasText.style.textShadow = outlineColor === null ? 'none' : `-1px -1px 0 ${outlineColor}, 1px -1px 0 ${outlineColor}, -1px 1px 0 ${outlineColor}, 1px 1px 0 ${outlineColor}`;
}

function validateTextInput(sectionId) {
    const textInput = document.getElementById(`text-input-${sectionId}`).value.trim();
    const fontStyleButton = document.querySelector(`#font-style-${sectionId}`).previousElementSibling;
    const fontColorPicker = document.querySelector(`#font-color-div-${sectionId}`);
    const outlineColorPicker = document.querySelector(`#outline-color-div-${sectionId}`);

    const fontStyleLabel = document.getElementById(`font-style-required-${sectionId}`);
    
    // Reset styles and labels
    fontStyleButton.style.borderColor = '';
        fontStyleLabel.style.display = 'none';
    
    let isValid = true;

    if (textInput !== '') {
        if (fontStyleButton.textContent.includes('Select a Font Style')) {
            fontStyleButton.style.borderColor = 'red';
            fontStyleLabel.style.display = 'inline';
            isValid = false;
        }

        
        // Show the controls
        fontStyleButton.parentElement.parentElement.parentElement.style.display = 'flex';
        fontColorPicker.style.display = 'block';
        outlineColorPicker.style.display = 'block';
        toggleCenterButtons(true);
    } else {
        // Hide the controls if no text is entered
        fontStyleButton.parentElement.parentElement.parentElement.style.display = 'none';
        fontColorPicker.style.display = 'none';
        outlineColorPicker.style.display = 'none';
        toggleCenterButtons(false);
    }

    return isValid;
}

document.addEventListener('keydown', (e) => {
    if (e.key === 'Delete') {
        const selectedTextBox = document.querySelector('.editable-text.selected, .editable-text.selected2');
        if (selectedTextBox) {
            const sectionId = selectedTextBox.id.replace('editable-text-', '');
            selectedTextBox.remove();

            // Clear the text input box
            const textInput = document.getElementById(`text-input-${sectionId}`);
            textInput.value = '';

            // Reset the font style, font color, and outline color to default values
            const fontStyleButton = document.querySelector(`#font-style-${sectionId}`).previousElementSibling;
            const fontColorPicker = document.querySelector(`#font-color-div-${sectionId}`);
            const outlineColorPicker = document.querySelector(`#outline-color-div-${sectionId}`);

            fontStyleButton.innerHTML = `Select a Font Style <svg class="dropdown-arrow" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/></svg>`;
            fontStyleButton.value = '';
            fontStyleButton.style.fontFamily = '';
            
            fontStyleButton.parentElement.parentElement.parentElement.style.display = 'none';
            fontColorPicker.style.display = 'none';
            outlineColorPicker.style.display = 'none';
        }
    }
});

    // Function to show/hide center buttons
function toggleCenterButtons(show) {
    const toggleSnapGrid = document.getElementById('toggleSnapGrid');
    const horizontalButton = document.getElementById("horizontalCenter");
    const verticalButton = document.getElementById("verticalCenter");
    horizontalButton.classList.remove('hidden');
    verticalButton.classList.remove('hidden');
    if (show) {
        horizontalButton.classList.remove('hidden');
        verticalButton.classList.remove('hidden');
        toggleSnapGrid.classList.remove('hidden');
    } else {
        horizontalButton.classList.add('hidden');
        verticalButton.classList.add('hidden');
        toggleSnapGrid.classList.add('hidden');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const snapButton = document.getElementById('toggleSnapGrid');
    const horizButton = document.getElementById('horizontalCenter');
    const vertButton = document.getElementById('verticalCenter');

    let hoverTimeout;

    function showDescription(button) {
        const description = button.querySelector('.description');
        description.style.visibility = 'visible';
        description.style.opacity = '1';
    }

    function hideDescription(button) {
        const description = button.querySelector('.description');
        description.style.visibility = 'hidden';
        description.style.opacity = '0';
    }

    function handleMouseOver(button) {
        button.addEventListener('mouseover', function() {
            const img = this.querySelector('img');
            if (button.id === 'toggleSnapGrid') {
                img.src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
            } else if (button.id === 'horizontalCenter') {
                img.src = `${window.shopifyAssetPaths.grid.horizontalCenterWhite}`;
            } else if (button.id === 'verticalCenter') {
                img.src = `${window.shopifyAssetPaths.grid.verticalCenterWhite}`;
            }
            hoverTimeout = setTimeout(() => showDescription(button), 1000);
        });

        button.addEventListener('mouseout', function() {
            const img = this.querySelector('img');
            clearTimeout(hoverTimeout);
            hideDescription(button);
            if (button.id === 'toggleSnapGrid') {
                if (this.classList.contains('active')) {
                    img.src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
                } else {
                    img.src = `${window.shopifyAssetPaths.grid.snapGrid}`;
                }
            } else if (button.id === 'horizontalCenter') {
                img.src = `${window.shopifyAssetPaths.grid.horizontalCenter}`;
            } else if (button.id === 'verticalCenter') {
                img.src = `${window.shopifyAssetPaths.grid.verticalCenter}`;
            }
        });
    }

    handleMouseOver(snapButton, 'Toggle Snap Grid');
    handleMouseOver(horizButton, 'Horizontal Center');
    handleMouseOver(vertButton, 'Vertical Center');

    snapButton.addEventListener('click', function() {
        this.classList.toggle('active');
        const img = this.querySelector('img');
        if (this.classList.contains('active')) {
            img.src = `${window.shopifyAssetPaths.grid.snapGridWhite}`;
        } else {
            img.src = `${window.shopifyAssetPaths.grid.snapGrid}`;
        }
    });

    // Add a document-wide event listener only once for deselection
    document.addEventListener('click', (e) => {
        const protectedTarget = e.target.closest(
            '#toggleSnapGrid, #horizontalCenter, #verticalCenter, .snap-button, .center-button1, .center-button2'
        );

        // If one of the action buttons was clicked, do nothing
        if (protectedTarget) {
            return;
        }

        let itemSelected = false;

        document.querySelectorAll('.editable-text, .editable-art').forEach(el => {
            if (!el.contains(e.target)) {
                el.classList.remove('selected');
                el.classList.remove('selected2');
            } else {
                itemSelected = true;
            }
        });

        toggleCenterButtons(itemSelected);
    });

    // Add a document-wide event listener only once for selection
    document.addEventListener('click', (e) => {
        const protectedTarget = e.target.closest(
            '#toggleSnapGrid, #horizontalCenter, #verticalCenter, .snap-button, .center-button1, .center-button2'
        );

        // Clicking one of these buttons should not change current selection
        if (protectedTarget) {
            return;
        }

        const selectedTextBox = e.target.closest('.editable-text');

        if (!selectedTextBox) {
            document.querySelectorAll('.editable-text').forEach(el => {
                el.classList.remove('selected');
                el.classList.remove('selected2');
            });

            toggleCenterButtons(false);
            return;
        }

        e.stopPropagation();

        document.querySelectorAll('.editable-text').forEach(el => {
            el.classList.remove('selected');
            el.classList.remove('selected2');
        });

        const textOverlay = selectedTextBox.closest('.text-overlay');

        if (textOverlay) {
            const canvasId = textOverlay.id.replace('TextOverlay', 'Canvas');
            const canvas = document.getElementById(canvasId);

            if (canvas) {
                const context = canvas.getContext('2d');
                const canvasColor = context.fillStyle;

                let flag = 0;

                switch (canvasColor) {
                    case '#ffffff':
                    case '#c2c2c2':
                    case '#c0c494':
                    case '#ffbd0d':
                    case '#fce60d':
                        selectedTextBox.classList.add('selected');
                        flag = 1;
                        break;

                    case '#060808':
                    case '#8d8c8c':
                    case '#552132':
                    case '#862838':
                    case '#c52c2c':
                    case '#da4b12':
                    case '#344e30':
                    case '#1b234b':
                    case '#73519e':
                    case '#2f5fa7':
                    case '#44b15c':
                    case '#8fa9dd':
                        selectedTextBox.classList.add('selected2');
                        flag = 1;
                        break;
                }

                if (flag === 0) {
                    const rgb = hexToRgb(canvasColor);

                    const brightness = Math.sqrt(
                        0.299 * (rgb.r * rgb.r) +
                        0.587 * (rgb.g * rgb.g) +
                        0.114 * (rgb.b * rgb.b)
                    );

                    if (brightness > 150) {
                        selectedTextBox.classList.add('selected');
                    } else {
                        selectedTextBox.classList.add('selected2');
                    }
                }

                toggleCenterButtons(true);
            }
        }
    });

    function hexToRgb(hex) {
        // Remove the leading # if present
        hex = hex.replace(/^#/, '');
    
        // Convert 3-digit HEX to 6-digit HEX
        if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
        }
    
        const bigint = parseInt(hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
    
        return { r, g, b };
    }
    });

function updateCanvasText(section) {
    const textInputEl = document.getElementById(`text-input-${section.id}`);
    const textInput = textInputEl.value;
    const combinedOverlay = document.getElementById(`${section.title.replace(' ', '')}TextOverlay`);
    const tentCanvas = document.getElementById(`${section.title.replace(' ', '')}Canvas`);

    if (!combinedOverlay || !tentCanvas) return;

    let editableText = combinedOverlay.querySelector('.editable-text');
    let textContent;

    // If there is no text, remove existing element and stop
    if (textInput.trim() === '') {
        if (editableText) {
            editableText.remove();
        }
        autoResizeTextarea(textInputEl);
        return;
    }

    // Create only once
    if (!editableText) {
        editableText = document.createElement('div');
        editableText.id = `editable-text-${section.id}`;
        editableText.className = 'editable-text';
        editableText.draggable = true;

        editableText.innerHTML = `
            <div class="text-content" contenteditable="false" spellcheck="false"></div>
            <div class="dot top-left"></div>
            <div class="dot top-right"></div>
            <div class="dot bottom-left"></div>
            <div class="dot bottom-right"></div>
            <div class="dot rotate"></div>
            <div class="rotate-handle"></div>
        `;

        combinedOverlay.appendChild(editableText);

        textContent = editableText.querySelector('.text-content');

        // Default position when first created
        editableText.style.left = `${(tentCanvas.offsetWidth / 2) - 14}px`;
        editableText.style.top = `${(tentCanvas.offsetHeight / 2) - 10}px`;
        editableText.style.fontSize = '16px';

        makeTextDraggable(editableText, combinedOverlay);
        makeTextResizable(editableText, textContent, combinedOverlay);
        textElementDoubleClickSetup(editableText, textContent, textInputEl, section);
        makeTextRotatable(editableText);
    } else {
        textContent = editableText.querySelector('.text-content');
    }
    editableText.classList.add('selected');

    // Keep overlay aligned to canvas
    updateOverlayPositionAndSize(section.title);
    combinedOverlay.style.display = 'flex';
    combinedOverlay.style.alignItems = 'center';
    combinedOverlay.style.justifyContent = 'center';

    // Ensure center lines exist
    if (!combinedOverlay.querySelector('.center-line.horizontal')) {
        combinedOverlay.insertAdjacentHTML(
            'beforeend',
            `<div class="center-line horizontal"></div>
             <div class="center-line vertical"></div>`
        );
    }

    // Update text only if textarea changed externally
    const sanitizedHtml = sanitizeInput(textInput);
    if (textContent.innerHTML !== sanitizedHtml) {
        textContent.innerHTML = sanitizedHtml;
    }

    // Apply styling to existing element
    const fontStyle = document.querySelector(`#font-style-${section.id}`).previousElementSibling.value.trim() || 'Arial';
    const fontColor = document.getElementById(`font-color-${section.id}`).textContent.trim() || 'Black';
    const outlineColor = document.getElementById(`outline-color-${section.id}`).textContent.trim() || null;

    const savedRotation = editableText.dataset.rotation || 0;
    editableText.style.transform = `rotate(${savedRotation}deg)`;

    updateFontStyle(editableText, fontStyle);
    updateFontColor(editableText, fontColor);
    updateOutlineColor(editableText, outlineColor);

    adjustTextboxSize(editableText, textContent);
    autoResizeTextarea(textInputEl);
}

function makeTextRotatable(textElement) {
    const rotateHandle = textElement.querySelector('.dot.rotate');
    if (!rotateHandle) return;

    let isRotating = false;
    const snapAngles = [0, 90, 180, 270, 360];
    const snapThreshold = 6; // degrees

    function getElementCenter(el) {
        const rect = el.getBoundingClientRect();
        return {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
        };
    }

    function getAngle(centerX, centerY, mouseX, mouseY) {
        return Math.atan2(mouseY - centerY, mouseX - centerX) * (180 / Math.PI);
    }

    function normalizeAngle(angle) {
        let normalized = angle % 360;
        if (normalized < 0) normalized += 360;
        return normalized;
    }

    function snapRotation(angle) {
        const normalized = normalizeAngle(angle);

        for (const snap of snapAngles) {
            if (Math.abs(normalized - snap) <= snapThreshold) {
                return snap === 360 ? 0 : snap;
            }
        }

        return normalized;
    }

    function onMouseDown(e) {
        e.preventDefault();
        e.stopPropagation();

        if (textElement.classList.contains('editing')) return;

        isRotating = true;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isRotating) return;

        const center = getElementCenter(textElement);
        const rawAngle = getAngle(center.x, center.y, e.clientX, e.clientY) + 90;
        const finalAngle = snapRotation(rawAngle);

        textElement.dataset.rotation = finalAngle;
        textElement.style.transform = `rotate(${finalAngle}deg)`;
    }

    function onMouseUp() {
        isRotating = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    }

    rotateHandle.addEventListener('mousedown', onMouseDown);
}

function textElementDoubleClickSetup(textElement, textContent, textInputEl, section) {
    const openEditor = (e) => {
        e.preventDefault();
        e.stopPropagation();
        enableTextEditMode(textElement, textContent, textInputEl, section);
    };

    textElement.addEventListener('dblclick', openEditor);
    textContent.addEventListener('dblclick', openEditor);
}

function adjustTextboxSize(textElement, textContent) {
    const oldWidth = textElement.offsetWidth || 0;
    const oldHeight = textElement.offsetHeight || 0;
    const oldLeft = parseFloat(textElement.style.left) || 0;
    const oldTop = parseFloat(textElement.style.top) || 0;

    const centerX = oldLeft + (oldWidth / 2);
    const centerY = oldTop + (oldHeight / 2);

    const computed = window.getComputedStyle(textElement);

    const paddingX =
        parseFloat(computed.paddingLeft || 0) +
        parseFloat(computed.paddingRight || 0);

    const paddingY =
        parseFloat(computed.paddingTop || 0) +
        parseFloat(computed.paddingBottom || 0);

    // Temporarily let the content size naturally so we can measure it
    const prevWidth = textContent.style.width;
    const prevHeight = textContent.style.height;

    textContent.style.width = 'auto';
    textContent.style.height = 'auto';

    const contentWidth = Math.ceil(textContent.scrollWidth);
    const contentHeight = Math.ceil(textContent.scrollHeight);

    const newWidth = Math.max(1, contentWidth + paddingX);
    const newHeight = Math.max(1, contentHeight + paddingY);

    textElement.style.width = `${newWidth}px`;
    textElement.style.height = `${newHeight}px`;
    textElement.style.left = `${centerX - (newWidth / 2)}px`;
    textElement.style.top = `${centerY - (newHeight / 2)}px`;

    // restore intended content sizing
    textContent.style.width = prevWidth;
    textContent.style.height = prevHeight;

    // refresh resize baseline to the newly fitted size
    textElement.dataset.baseWidth = newWidth;
    textElement.dataset.baseHeight = newHeight;
    textElement.dataset.baseFontSize =
        parseFloat(window.getComputedStyle(textElement).fontSize) || 16;
}

function adjustTextboxSizeWhileEditing(textElement, textContent) {
    const oldWidth = textElement.offsetWidth || 0;
    const oldHeight = textElement.offsetHeight || 0;
    const oldLeft = parseFloat(textElement.style.left) || 0;
    const oldTop = parseFloat(textElement.style.top) || 0;

    const centerX = oldLeft + (oldWidth / 2);
    const centerY = oldTop + (oldHeight / 2);

    const computed = window.getComputedStyle(textElement);

    const paddingX =
        parseFloat(computed.paddingLeft || 0) +
        parseFloat(computed.paddingRight || 0);

    const paddingY =
        parseFloat(computed.paddingTop || 0) +
        parseFloat(computed.paddingBottom || 0);

    const prevWidth = textContent.style.width;
    const prevHeight = textContent.style.height;

    textContent.style.width = 'auto';
    textContent.style.height = 'auto';

    const contentWidth = Math.ceil(textContent.scrollWidth);
    const contentHeight = Math.ceil(textContent.scrollHeight);

    const newWidth = Math.max(1, contentWidth + paddingX);
    const newHeight = Math.max(1, contentHeight + paddingY);

    textElement.style.width = `${newWidth}px`;
    textElement.style.height = `${newHeight}px`;
    textElement.style.left = `${centerX - (newWidth / 2)}px`;
    textElement.style.top = `${centerY - (newHeight / 2)}px`;

    textContent.style.width = prevWidth;
    textContent.style.height = prevHeight;
}

function autoResizeTextarea(textarea) {
    textarea.style.height = 'auto';
    if(textarea.scrollHeight != 0){
        textarea.style.height = (textarea.scrollHeight) + 'px';
    }
    else{
        textarea.style.height = '40px';
    }
    
}

function placeCaretAtEnd(el) {
    el.focus();

    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);

    selection.removeAllRanges();
    selection.addRange(range);
}

function exitTextEditMode(textElement, textContent, textInputEl, section) {
    textContent.setAttribute('contenteditable', 'false');
    textElement.classList.remove('editing');
    textContent.blur();

    textInputEl.value = sanitizeInput(textContent.innerText.replace(/\r/g, ''));
    adjustTextboxSize(textElement, textContent);
    validateTextInput(section.id);
    autoResizeTextarea(textInputEl);
}

function enableTextEditMode(textElement, textContent, textInputEl, section) {
    textContent.setAttribute('contenteditable', 'true');
    textElement.classList.add('editing');
    placeCaretAtEnd(textContent);

    let rafId = null;

    const syncEditorChanges = () => {
        rafId = null;

        textInputEl.value = sanitizeInput(textContent.innerText.replace(/\r/g, ''));
        adjustTextboxSizeWhileEditing(textElement, textContent);
        validateTextInput(section.id);
        autoResizeTextarea(textInputEl);
    };

    const queueSync = () => {
        if (rafId !== null) return;
        rafId = requestAnimationFrame(syncEditorChanges);
    };

    const handleInput = () => {
        queueSync();
    };

    const handleBlur = () => {
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            syncEditorChanges();
        }

        exitTextEditMode(textElement, textContent, textInputEl, section);
        cleanup();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.preventDefault();

            if (rafId !== null) {
                cancelAnimationFrame(rafId);
                syncEditorChanges();
            }

            exitTextEditMode(textElement, textContent, textInputEl, section);
            cleanup();
            return;
        }

        if (e.key === 'Enter') {
            e.preventDefault();

            const selection = window.getSelection();
            if (!selection.rangeCount) return;

            const range = selection.getRangeAt(0);
            range.deleteContents();

            const br = document.createElement('br');
            const zwsp = document.createTextNode('\u200B');

            range.insertNode(zwsp);
            range.insertNode(br);

            range.setStartAfter(zwsp);
            range.setEndAfter(zwsp);

            selection.removeAllRanges();
            selection.addRange(range);

            queueSync();
        }
    };

    function cleanup() {
        if (rafId !== null) {
            cancelAnimationFrame(rafId);
            rafId = null;
        }

        textContent.removeEventListener('input', handleInput);
        textContent.removeEventListener('blur', handleBlur);
        textContent.removeEventListener('keydown', handleKeyDown);
    }

    textContent.addEventListener('input', handleInput);
    textContent.addEventListener('blur', handleBlur);
    textContent.addEventListener('keydown', handleKeyDown);
}

let snapGridEnabled = false;

document.getElementById('toggleSnapGrid').addEventListener('click', function() {
    snapGridEnabled = !snapGridEnabled;
    if (snapGridEnabled) {
        this.classList.add('active');
    } else {
        this.classList.remove('active');
    }
});

function makeTextResizable(textElement, textContent, container) {
    const handles = {
        'top-left': textElement.querySelector('.dot.top-left'),
        'top-right': textElement.querySelector('.dot.top-right'),
        'bottom-left': textElement.querySelector('.dot.bottom-left'),
        'bottom-right': textElement.querySelector('.dot.bottom-right')
    };

    let isResizing = false;
    let activeHandle = null;

    let startX = 0;
    let startY = 0;
    let startWidth = 0;
    let startHeight = 0;
    let startLeft = 0;
    let startTop = 0;
    let baseWidth = 0;
    let baseHeight = 0;
    let baseFontSize = 16;

    const minWidth = 30;
    const minHeight = 20;
    const minFontSize = 6;

    function getNumber(value, fallback = 0) {
        const n = parseFloat(value);
        return isNaN(n) ? fallback : n;
    }

    function ensureResizeBaseline() {
        if (!textElement.dataset.baseWidth) {
            textElement.dataset.baseWidth = textElement.offsetWidth;
        }
        if (!textElement.dataset.baseHeight) {
            textElement.dataset.baseHeight = textElement.offsetHeight;
        }
        if (!textElement.dataset.baseFontSize) {
            textElement.dataset.baseFontSize = getNumber(window.getComputedStyle(textElement).fontSize, 16);
        }
    }

    function onHandleMouseDown(e, handleName) {
        e.preventDefault();
        e.stopPropagation();

        if (textElement.classList.contains('editing')) return;

        ensureResizeBaseline();

        isResizing = true;
        activeHandle = handleName;

        startX = e.clientX;
        startY = e.clientY;

        startWidth = textElement.offsetWidth;
        startHeight = textElement.offsetHeight;
        startLeft = getNumber(textElement.style.left);
        startTop = getNumber(textElement.style.top);

        baseWidth = getNumber(textElement.dataset.baseWidth, startWidth);
        baseHeight = getNumber(textElement.dataset.baseHeight, startHeight);
        baseFontSize = getNumber(textElement.dataset.baseFontSize, 16);

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isResizing || !activeHandle) return;

        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        let newWidth = startWidth;
        let newHeight = startHeight;
        let newLeft = startLeft;
        let newTop = startTop;

        switch (activeHandle) {
            case 'top-left':
                newWidth = startWidth - dx;
                newHeight = startHeight - dy;
                newLeft = startLeft + dx;
                newTop = startTop + dy;
                break;

            case 'top-right':
                newWidth = startWidth + dx;
                newHeight = startHeight - dy;
                newTop = startTop + dy;
                break;

            case 'bottom-left':
                newWidth = startWidth - dx;
                newHeight = startHeight + dy;
                newLeft = startLeft + dx;
                break;

            case 'bottom-right':
                newWidth = startWidth + dx;
                newHeight = startHeight + dy;
                break;
        }

        if (newWidth < minWidth) {
            if (activeHandle.includes('left')) {
                newLeft = startLeft + (startWidth - minWidth);
            }
            newWidth = minWidth;
        }

        if (newHeight < minHeight) {
            if (activeHandle.includes('top')) {
                newTop = startTop + (startHeight - minHeight);
            }
            newHeight = minHeight;
        }

        const widthScale = newWidth / baseWidth;
        const heightScale = newHeight / baseHeight;
        const scale = Math.min(widthScale, heightScale);

        const newFontSize = Math.max(minFontSize, baseFontSize * scale);

        textElement.style.width = `${newWidth}px`;
        textElement.style.height = `${newHeight}px`;
        textElement.style.left = `${newLeft}px`;
        textElement.style.top = `${newTop}px`;
        textElement.style.fontSize = `${newFontSize}px`;
    }

    function onMouseUp() {
        if (!isResizing) return;

        isResizing = false;
        activeHandle = null;

        adjustTextboxSize(textElement, textContent);

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('blur', onMouseUp);
    }

    Object.entries(handles).forEach(([handleName, handle]) => {
        if (!handle) return;
        handle.addEventListener('mousedown', (e) => onHandleMouseDown(e, handleName));
    });
}

function makeTextDraggable(textElement, container) {
    let isMouseDown = false;
    let isDragging = false;
    let startMouseX = 0;
    let startMouseY = 0;
    let startLeft = 0;
    let startTop = 0;

    const dragThreshold = 5;
    const snapThreshold = 10;
    let isSnappedX = false;
    let isSnappedY = false;

    function onMouseDown(e) {
        if (e.button !== 0) return;
        if (textElement.classList.contains('editing')) return;
        if (e.target.closest('.dot')) return; // rotate or resize handles manage themselves

        e.preventDefault();

        startMouseX = e.clientX;
        startMouseY = e.clientY;
        startLeft = parseFloat(textElement.style.left) || 0;
        startTop = parseFloat(textElement.style.top) || 0;

        isMouseDown = true;
        isDragging = false;

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        window.addEventListener('blur', onMouseUp);
    }

    function onMouseMove(e) {
        if (!isMouseDown) return;

        const movedX = Math.abs(e.clientX - startMouseX);
        const movedY = Math.abs(e.clientY - startMouseY);

        if (!isDragging && (movedX > dragThreshold || movedY > dragThreshold)) {
            isDragging = true;
            textElement.style.cursor = 'move';
        }

        if (!isDragging) return;

        e.preventDefault();

        let newX = startLeft + (e.clientX - startMouseX);
        let newY = startTop + (e.clientY - startMouseY);

        const containerRect = container.getBoundingClientRect();
        const textCenterX = newX + textElement.offsetWidth / 2;
        const textCenterY = newY + textElement.offsetHeight / 2;
        const containerCenterX = containerRect.width / 2;
        const containerCenterY = containerRect.height / 2;

        if (snapGridEnabled) {
            isSnappedX = Math.abs(textCenterX - containerCenterX) < snapThreshold;
            isSnappedY = Math.abs(textCenterY - containerCenterY) < snapThreshold;

            if (isSnappedX) {
                showCenterLine(container, 'vertical');
                newX = containerCenterX - textElement.offsetWidth / 2;
            } else {
                hideCenterLine(container, 'vertical');
            }

            if (isSnappedY) {
                showCenterLine(container, 'horizontal');
                newY = containerCenterY - textElement.offsetHeight / 2;
            } else {
                hideCenterLine(container, 'horizontal');
            }
        }

        textElement.style.left = `${newX}px`;
        textElement.style.top = `${newY}px`;
    }

    function onMouseUp() {
        isMouseDown = false;
        isDragging = false;
        hideCenterLines(container);

        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        window.removeEventListener('blur', onMouseUp);
    }

    textElement.addEventListener('mousedown', onMouseDown);

    const textContent = textElement.querySelector('.text-content');
    if (textContent) {
        textContent.addEventListener('mousedown', onMouseDown);
    }
}

function showCenterLine(container, direction) {
    container.querySelector(`.center-line.${direction}`).classList.add('visible');
}

function hideCenterLine(container, direction) {
    container.querySelector(`.center-line.${direction}`).classList.remove('visible');
}

function hideCenterLines(container) {
    container.querySelectorAll('.center-line').forEach(line => line.classList.remove('visible'));
}

// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {
    if (!event.target.matches('.custom-dropdown-button')) {
        const dropdowns = document.getElementsByClassName("custom-dropdown-content");
        for (let i = 0; i < dropdowns.length; i++) {
            const openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}
